import httpManager from "@/app/shared/utils/httpManager";

export async function downloadAudioIvr(id) {
  const url = `/strategies/${id}/download-audio-ivr/`;
  const response = await httpManager.getBlob(url);
  return response?.data;
}
